let currentSite;
let templates;

export default {
  get currentSite() { return currentSite; },
  set currentSite(value) { currentSite = value; },
  get templates() { return templates; },
  set templates(value) { templates = value; },
};
